module.exports = __webpack_public_path__ + "img/car.3f4972d.svg";